<template>
  <div class="step u-bg--grey">
    <div>
      <img src="@/assets/img/icons.svg#icon-check" width="20" height="20">
      <span>{{step.label}}
        <span v-for="(answer, key) in step.answers" :key="key">
          <span v-if="answer && answer.node"><span v-if="key < step.answers.length - 1">: </span> <strong>{{answer.node.title}}<span v-if="key < step.answers.length - 1">, </span></strong></span>
        </span>
      </span>
    </div>

    <router-link class="link u-color--blue" :to="{name: 'recommendation_pathology', query: href}">Modifier</router-link>
  </div>
</template>

<script>
  import qs from 'qs'

  export default {
    name: "Step",
    props: ['step', 'questionId'],
    computed: {
      href() {
        let query = this.$route.query
        let limitSplit = false

        let queryObj = {}

        Object.keys(query).map(key => {
          if (key !== 'reco' && !limitSplit) {
            let qId = key

            if (key.includes('q')) {
              qId = key.split('q')[1]
            }

            queryObj[key] = query[key]

            if (qId == this.questionId) {
              limitSplit = true
            }
          }
        })

        return queryObj
      }
    }
  }
</script>

<style lang="scss">
  .step {
    padding: rem(18px) rem(20px);
    margin-bottom: rem(20px);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    &:last-child {
      margin-bottom: rem(40px);
    }

    div {
      display: flex;
      align-items: center;
      max-width: rem(500px);

      span {
        @include montserratMedium;
        font-weight: 300;
        font-size: rem(16px);
        line-height: rem(24px);
        color: color(grey-soft);

        @include mq($until: MD) {
          font-size: rem(14px);
        }

        strong {
          color: color(grey-dark);
        }
      }

      img {
        margin-right: rem(10px);
      }
    }

    a {
      cursor: pointer;
    }

    @include mq($until: MD) {
      padding: rem(10px);

      .link {
        font-size: rem(12px);
        padding-left: rem(25px);
      }
    }
  }
</style>